import { render, staticRenderFns } from "./survey-funding-percent.vue?vue&type=template&id=34808a47"
import script from "./survey-funding-percent.component.ts?vue&type=script&lang=ts&external"
export * from "./survey-funding-percent.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports